import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import VuexPersistence from 'vuex-persist'
import { StudentBasicInfo } from '@/models/studentBasicInfo'
import { ObserverEvent } from '@/enum/Enum'

Vue.use(Vuex)

const plugins = []
// 持久化儲存到sessionStorage
plugins.push(
	new VuexPersistence({
		storage: window.sessionStorage,
	}).plugin,
)

const calculateAuthenticated = function(state: any) {
	let authenticated = !_.isNull(_.get(state, 'user').UserName)
	try {
		return authenticated
	} catch (e) {
		return false
	}
}

export default new Vuex.Store({
	state: {
		isShowLoginMenu: false,
		authenticated: false,
		user: {
			Id: null,
			UserName: null,
			Name: null,
			Role: null,
			StudentBasicInfo: new StudentBasicInfo(),
			HashCode: null,
		},
		waittingIntervalId: null,
		logoutIntervalId: null,
		observerUpdateEvent: {
			myCourse: false, //我的課程
			stepOperation: false, //本階段已加選課程
			operationRecord: false, //操作紀錄
			queryClassList: false, //加退選作業
		},
		selectedClass: new Array<string>(),
		waitingClass: new Array<string>(),
	},
	getters: {
		userName: state => {
			return _.get(state, 'user.Name')
		},
		userId: state => {
			return _.get(state, 'user.Id')
		},
		studentBasicInfo: state => {
			return _.get(state, 'user.StudentBasicInfo')
		},
		hashCode: state => {
			return _.get(state, 'user.HashCode')
		},
		selectedClass: state => {
			return _.get(state, 'selectedClass')
		},
		waitingClass: state => {
			return _.get(state, 'waitingClass')
		},
	},
	mutations: {
		setShowLoginMenu(state, status) {
			state.isShowLoginMenu = status && !state.authenticated
		},
		setUser(state, user) {
			state.user = user
			state.authenticated = calculateAuthenticated(state)
		},
		resetState(state) {
			state.authenticated = false
			state.user = {
				Id: null,
				UserName: null,
				Name: null,
				Role: null,
				StudentBasicInfo: new StudentBasicInfo(),
				HashCode: null,
			}
			state.isShowLoginMenu = false
			state.waittingIntervalId = null
			state.logoutIntervalId = null
			state.observerUpdateEvent = {
				myCourse: false,
				stepOperation: false,
				operationRecord: false,
				queryClassList: false,
			}
			state.selectedClass = []
			state.waitingClass = []
		},
		setWaittingIntervalId(state, value) {
			state.waittingIntervalId = value
		},
		setLogoutIntervalId(state, value) {
			state.logoutIntervalId = value
		},
		setObserverUpdateEvent(state, value: { key: ObserverEvent; value: boolean }) {
			_.set(state.observerUpdateEvent, value.key, value.value)
		},
		setSelectedClass(state, value) {
			state.selectedClass = value
		},
		setWaitingClass(state, value) {
			state.waitingClass = value
		},
	},
	actions: {
		onLand(context) {
			return Vue.prototype.$axios.get(`api/user/me`).then((userResponse: { data: any }) => {
				context.commit(`setUser`, userResponse.data)
			})
		},
		logout(context) {
			context.commit('resetState')
		},
		addSelectedClass(context, value: string) {
			context.state.selectedClass.push(value)
			_.set(context.state.observerUpdateEvent, ObserverEvent.MyCourse, true)
			_.set(context.state.observerUpdateEvent, ObserverEvent.OperationRecord, true)
		},
		removeSelectedClass(context, value: string) {
			_.remove(context.state.selectedClass, item => item == value)
			_.set(context.state.observerUpdateEvent, ObserverEvent.OperationRecord, true)
			_.set(context.state.observerUpdateEvent, ObserverEvent.QueryClassList, true)
		},
		removeSelectedClassByList(context, value: string) {
			_.remove(context.state.selectedClass, item => item == value)
			_.set(context.state.observerUpdateEvent, ObserverEvent.MyCourse, true)
			_.set(context.state.observerUpdateEvent, ObserverEvent.OperationRecord, true)
		},
		addWaitingClass(context, value: string) {
			context.state.waitingClass.push(value)
			_.set(context.state.observerUpdateEvent, ObserverEvent.OperationRecord, true)
			_.set(context.state.observerUpdateEvent, ObserverEvent.StepOperation, true)
		},
		removeWaitingClassByOperationList(context, value: string) {
			_.remove(context.state.waitingClass, item => item == value)
			_.set(context.state.observerUpdateEvent, ObserverEvent.OperationRecord, true)
			_.set(context.state.observerUpdateEvent, ObserverEvent.QueryClassList, true)
		},
		removeWaitingClassByQueryList(context, value: string) {
			_.remove(context.state.waitingClass, item => item == value)
			_.set(context.state.observerUpdateEvent, ObserverEvent.StepOperation, true)
			_.set(context.state.observerUpdateEvent, ObserverEvent.OperationRecord, true)
		},
	},
	modules: {},
	plugins: plugins,
})
